import './App.css';
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import Home from "./pages/home/home";
import Navbar from "./component/navbar/navbar";
import Footer from "./component/footer/footer";
import ContactPage from './pages/contact/ContactPage';
import AboutPage from './pages/about/AboutPage';
import ScrollToTop from "./component/scrollToTop/ScrollToTop";
import TopButton from './component/topButton/TopButton';
import SignupPage from './pages/signup/SignupPage';
import ProductsPage from './pages/products/ProductsPage';
import PreviewModal from './component/navbar/PreviewModal';
import FaqPage from './pages/faq-page/FaqPage';
import WpButton from './component/wpIcon/WpIcon';



function App() {
  return (
    <div className="App">
      <Router>
      <ScrollToTop />
        <Navbar />
        <PreviewModal/>
        <div className="mt-0">
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<AboutPage />} />
            <Route path='/products' element={<ProductsPage />} />
            <Route path='/contact' element={<ContactPage />} />
            <Route path='/faq' element={<FaqPage />} />
            {/* <Route path='/sign-up' element={<SignupPage />} /> */}
          </Routes>
        </div>
        <Footer />
        <WpButton/>
        <TopButton />
      </Router>
    </div>
  );
}

export default App;
